import TextareaWysiwyg from "@components/wysiwyg/textarea-wysiwyg";
import { classNames } from "@helpers/css";

const AiKnowledgePreview = ({
  value,
  label,
  placeholder,
  onOpen,
}: {
  value: string | null;
  label: string;
  placeholder: string;
  onOpen: () => void;
}) => {
  const hasValue = !!value?.trim();

  return (
    <button
      type="button"
      className="w-full rounded-md border border-gray-200 bg-white p-4 text-left hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
      onClick={onOpen}
      aria-label={`Edit ${label}`}
    >
      <div className="mb-2 text-sm font-medium text-gray-900">{label}</div>
      {hasValue ? (
        <div className="relative max-h-[200px] overflow-hidden">
          <TextareaWysiwyg
            value={value}
            editable={false}
            fullWidth
            deps={[value]}
            className={classNames("pointer-events-none text-gray-700")}
          />
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-t from-white to-white/0" />
        </div>
      ) : (
        <div className="text-sm text-gray-500">{placeholder}</div>
      )}
    </button>
  );
};

export default AiKnowledgePreview;
